export class ApplicationUser {
    constructor(
      public username: string,
      public role: string,
      public sinequaProfile: string,
      public contactEmail: string,
      public company: string,
      public uid : string,
      public password : string
    ) {}
  }
  